import { useEffect, useState } from "react";
import { useMediaInputContext } from "@/providers/media-input-provider/media-input-provider";

export const useCreateProcessInputsHandler = () => {
  const context = useMediaInputContext();
  const [songFile, setSongFile] = useState<File | null>(null);
  const [isActive, setIsActive] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    let file: File | null = null;
    switch (context.uploadedFiles.activeTab) {
      case "localFile":
        file = context.uploadedFiles.localFile?.songFile ?? null;
        break;
      case "youtube":
        file = context.uploadedFiles.youtube?.songFile ?? null;
        break;
      case "recordAudio":
        file = context.uploadedFiles.recordAudio?.songFile ?? null;
        break;
    }
    setSongFile(file);
    setIsActive(!!file);
  }, [
    context.uploadedFiles.activeTab,
    context.uploadedFiles.localFile?.songFile,
    context.uploadedFiles.youtube?.songFile,
    context.uploadedFiles.recordAudio?.songFile,
  ]);

  return {
    songFile,
    isActive,
    isLoading,
    setIsActive,
    setIsLoading,
    setSongFile,
  };
};
